module.exports = __webpack_public_path__ + "i18n/ko.d043683db3568720b8c57b384c54cca4.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ko.json
// module id = 1310
// module chunks = 59